/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

var popupProps = {
  attach: {
    type: [String, Function],
    "default": "body"
  },
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  delay: {
    type: [Number, Array]
  },
  destroyOnClose: Boolean,
  disabled: Boolean,
  hideEmptyPopup: Boolean,
  overlayClassName: {
    type: [String, Object, Array]
  },
  overlayInnerClassName: {
    type: [String, Object, Array]
  },
  overlayInnerStyle: {
    type: [Boolean, Object, Function]
  },
  overlayStyle: {
    type: [Boolean, Object, Function]
  },
  placement: {
    type: String,
    "default": "top"
  },
  popperOptions: {
    type: Object
  },
  showArrow: Boolean,
  trigger: {
    type: String,
    "default": "hover",
    validator: function validator(val) {
      if (!val) return true;
      return ["hover", "click", "focus", "mousedown", "context-menu"].includes(val);
    }
  },
  triggerElement: {
    type: [String, Function]
  },
  visible: {
    type: Boolean,
    "default": void 0
  },
  modelValue: {
    type: Boolean,
    "default": void 0
  },
  defaultVisible: Boolean,
  zIndex: {
    type: Number
  },
  onOverlayClick: Function,
  onScroll: Function,
  onScrollToBottom: Function,
  onVisibleChange: Function
};

export { popupProps as default };
//# sourceMappingURL=props.mjs.map
